import { IDocumentChangelogState } from './document-changelog.types';

export const namespace = 'documentChangelog';

export const getDefaultState: () => IDocumentChangelogState = () => ({
  posts: {},
});

export enum EDocumentChangelogAction {
  AddEntry = 'addEntry',
  DeletePost = 'deletePost',
}

export enum EDocumentChangelogMutation {
  AddEntry = 'addEntry',
  DeletePost = 'deletePost',
}
